import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LedgerdetailsService {

  private messageSourceCP = new BehaviorSubject("GENERAL"); //GENERAL is 'default message'
  currentMessageCP = this.messageSourceCP.asObservable();

  constructor() { }

  changeMessageCP(messageCP: string) {
    this.messageSourceCP.next(messageCP)
  }

}